import { MockExam } from "./MockExam";
export default MockExam;
